/** O símbolo do mapa em SVG, para o painel e as fichas (mesma forma de `look.ts`). */
import { COR_SEM_DADO } from './faixas';
import { contornoDaForma, type Forma } from './look';

export function Simbolo(props: { forma: Forma; cor: string | null; tamanho?: number; anel?: boolean; titulo?: string }) {
  const t = props.tamanho ?? 13;
  const r = props.anel ? 3.6 : 4.8;
  const pontos = (raio: number) =>
    contornoDaForma(props.forma)
      .map(([x, y]) => `${(x * raio).toFixed(2)},${(y * raio).toFixed(2)}`)
      .join(' ');
  return (
    <svg viewBox="-6.5 -6.5 13 13" width={t} height={t} aria-hidden={props.titulo ? undefined : true} className="shrink-0">
      {props.titulo && <title>{props.titulo}</title>}
      {props.anel && <polygon points={pontos(r + 2)} fill="none" stroke="rgba(255,255,255,0.9)" strokeWidth="1" />}
      <polygon
        points={pontos(r)}
        fill={props.cor ?? 'none'}
        stroke={props.cor ? 'rgba(8,13,24,0.9)' : COR_SEM_DADO}
        strokeWidth="1"
        strokeDasharray={props.cor ? undefined : '2 1.5'}
        strokeLinejoin="round"
      />
    </svg>
  );
}
